import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimeDkeyHoldEaseIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.006 21C21.42 21 21.65 20.554 21.389 20.254L14.472 12.287C14.329 12.122 14.329 11.877 14.472 11.712L21.389 3.74499C21.649 3.44499 21.42 2.99899 21.006 2.99899H3.5C3.224 2.99899 3 3.22299 3 3.49899V20.499C3 20.775 3.224 20.999 3.5 20.999L21.006 21Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimeDkeyHoldEaseIcon.displayName = 'TimeDkeyHoldEaseIcon';
